var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgCallEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1318,
    height: 506,
    viewBox: "0 0 1318 506",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7794",
    "data-name": "Rectangle 7794",
    width: 259,
    height: 230,
    transform: "translate(0 205)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30830",
    "data-name": "Group 30830",
    transform: "translate(0 -67)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_162",
    "data-name": "Mask Group 162",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "video-camera-fill",
    transform: "translate(-103.09 205)",
    opacity: 0.14
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13754",
    "data-name": "Path 13754",
    d: "M261.745,112.415v145a24.2,24.2,0,0,1-24.166,24.166H68.416A60.485,60.485,0,0,1,8,221.163v-145A24.194,24.194,0,0,1,32.166,52H201.33A60.485,60.485,0,0,1,261.745,112.415Zm102.73-28.575a12.088,12.088,0,0,0-12.059-.041L292,118.323a12.083,12.083,0,0,0-6.089,10.491v75.95A12.083,12.083,0,0,0,292,215.256l60.415,34.523a12.083,12.083,0,0,0,18.077-10.492v-145a12.08,12.08,0,0,0-6.019-10.45Z",
    transform: "translate(-8 -52)",
    fill: "#b3ceee"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_16603",
    "data-name": "Group 16603",
    transform: "translate(23 22)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1630",
    "data-name": "Ellipse 1630",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(87 81)",
    fill: "#f4f8fd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1637",
    "data-name": "Ellipse 1637",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1250 515)",
    fill: "#f4f8fd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1633",
    "data-name": "Ellipse 1633",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(41 108)",
    fill: "#f4f8fd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1634",
    "data-name": "Ellipse 1634",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(124 146)",
    fill: "#f4f8fd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1632",
    "data-name": "Ellipse 1632",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(26 45)",
    fill: "#f4f8fd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1631",
    "data-name": "Ellipse 1631",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(114 47)",
    fill: "#f4f8fd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1638",
    "data-name": "Ellipse 1638",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(1277 481)",
    fill: "#f4f8fd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCallEnd);
export default __webpack_public_path__ + "static/media/bg-call-end.3af59e1e9e44beec3fa2a80dea0208fc.svg";
export { ForwardRef as ReactComponent };